import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const HelpAndSupport = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const Add_order = (e) => {
    e.preventDefault(); // Prevent form reload
    setShowModal(true); // Show modal
  };

  const closeModal = () => {
    setShowModal(false);
    navigate(-1); // Navigate back
  };

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <div className="page-content">
        <div className="card card-style">
          <div className="content">
            <form method="post" onSubmit={Add_order}>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input type="text" name="dealer_firm_name" className="form-control" placeholder="Name" required />
                <label className="color-highlight">Name</label>
              </div>

              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input type="number" name="dealer_number" className="form-control" placeholder="Number" required />
                <label className="color-highlight">Number</label>
              </div>

              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input type="text" name="dealer_address" className="form-control" placeholder="Message" required />
                <label className="color-highlight">Message</label>
              </div>

              <button
                type="submit"
                style={{ width: "100%" }}
                className="btn btn-3d btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s border-red-dark bg-red-light"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />

      {/* Modal Alert */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            <h3>Support Request Submitted!</h3>
            <p>Thank you for reaching out to us. Our support team will get back to you shortly.</p>
            <button
              onClick={closeModal}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                border: "none",
                background: "#ff4d4d",
                color: "#fff",
                borderRadius: "5px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpAndSupport;
